import ScalebarMenu from "./ScalebarMenu";
import O from "./O";
import getChangesByCellLocation from './getChangesByCellLocation';

import { useDispatch, useSelector } from 'react-redux';
import Id from './IdFactory';
import React, { useState, useMemo } from 'react';
import A from './ActionCreators';
import SidebarChannelSelector from './SidebarChannelSelector';
import SubregionOutlineMenu from './SubregionOutlineMenu';
import NodeExpansionItemAdder from './NodeExpansionItemAdder';
import SpacingEditor from './SpacingEditor';
import CollapsibleSection from './CollapsibleSection';
import ImageRegionChoiceSubmenu from './ImageRegionChoiceSubmenu';
import { isUsingWebdriver } from './versionConfig';

import ScalebarEditor from './ScalebarEditor';
import { useContext } from 'react';

import { FigureInteractionEventDispatch } from './Contexts';

import { SelectedItemsContext } from './Contexts';
import { SelectedItemInfo } from './SelectedItemProvider';

const expansionHeight = 400;
const sidebarWidth = 200;

const DEFAULT_OPEN_SET = new Set(["scalebar","imageFilters"])

const sectionHeaderStyle = {
  fontSize:12, 
  fontWeight:'bold',
}

// CAN EDIT TEMPLATE:
//  * if there a single template referenced from the selectedFigureItems



const menuEventHandler = (figurePanelId,dispatch) => function({
  event,
  selectedNodes,
  selectedTemplateNodes,
  type,
  properties,
}){

  
  if( !figurePanelId ){
    throw Error("FIGURE PANEL ID REQUIRED IN HANDLE MENU EVENT!");
  }else{
  }

    //decide what kind of event we're dispatching

   

    switch(type){
      case "add":{

        if( selectedNodes && selectedNodes.length > 0 ){

          let { args } = event;
          

          dispatch(A.insertNodesInEvaluatedTemplateNodes({
            figurePanelId,
            targetLocations:selectedNodes.map(({nodeId,cellLocation}) => ({inside:nodeId,cellLocation,
              nodeId:Id()
            })),
            args

          }))

        }

        break;
      }
      case "change":{

        if( selectedNodes.length > 0 ){

          debugger;

          let byCellLocation = getChangesByCellLocation({
            targetLocations:(selectedNodes),
            properties,
            
          });



          dispatch(A.setCellsValueProperties({
            figurePanelId,
            byCellLocation,
          }))

        }else if( selectedTemplateNodes.length > 0 ){

          throw Error("Haven't linked dispatch to editing template node properties.");
        }


        break;
      }
      default:{
        throw Error(`Event type ${type} is not a handled menu event.`);
      }
    }
  }

let componentOrder = {
  scalebar:ScalebarMenu,
  addItems:NodeExpansionItemAdder,
  //position:TemplatePositionLock,
  spacing:SpacingEditor,
  setRegionVariable:ImageRegionChoiceSubmenu,
  regionOutlines:SubregionOutlineMenu,
  imageFilters:SidebarChannelSelector, //<SidebarChannelSelector
}



export default function FigureInfoSidebar({
  figurePanelId, 
  initialArgs, 
}){


  

  let dispatch = useDispatch();

  return null;

  const handleMenuEvent = useMemo(() => menuEventHandler(figurePanelId,dispatch),[figurePanelId,dispatch]);

  const {possibleActions} = useContext(SelectedItemInfo);

  const selectedFigureItems = useContext(SelectedItemsContext);

  const onFigureInteractionEvent = useContext(FigureInteractionEventDispatch);


  const { unifiedGroup } = useContext( SelectedItemInfo );


  if( !selectedFigureItems.expansionNodes || selectedFigureItems.expansionNodes.length === 0){
    return null;
  }

  if( Object.keys(possibleActions||{}).length === 0 ){
    return null;
  }



  let data = unifiedGroup;


  let selectedTemplateNodes = selectedFigureItems.templateNodes || [];
  let selectedNodes = selectedFigureItems.expansionNodes || [];
  let selectedCells = selectedFigureItems.cells || [];

     
  


  const standardEventResponse = e => {
    console.log("Standard event...");
    console.log(e);
    handleMenuEvent({
      e,
      type:"change",
      figurePanelId,
      selectedNodes,
      selectedTemplateNodes,
      properties:e.properties,
    })
  }

  const customEventHandler = ({
    position:({event,position}) => {
      handleMenuEvent({
        figurePanelId,
        event,
        selectedNodes,
        selectedTemplateNodes,
        type:"change",
        properties:{
          "position.base":position
        }
      })
    },
    addItems:({event,type,args}) => {

      if( type ){
        onFigureInteractionEvent({event,type,args})
        return;
      }

      onFigureInteractionEvent({
        type:"add",
        event,
        args
      })
      if( selectedNodes && selectedNodes.length > 0 ){ 
        
      }

    },
    imageFilters:({event,targetNodes,properties}) => {

      debugger;

      handleMenuEvent({
        e:event,
        type:"change",
        figurePanelId,
        selectedNodes,
        selectedTemplateNodes,
        properties,
      })
    },
    regionOutlines:({event,targetNodes}) => {

      handleMenuEvent({
        e:event,
        type:"change",
        figurePanelId,
        selectedNodes:targetNodes,
        selectedTemplateNodes,
        properties:event.properties,
      })

    }
  })

  let possibleActionEntries = Object.entries(possibleActions||{});


  let sidebarMenus = possibleActionEntries.map(([menuKey,menuArgs]) => {

    if( !menuArgs ){
      return null;
    }

    let component = componentOrder[menuKey];

    if( !component ){
      component = null
    }


    if( !selectedNodes || selectedNodes.length === 0 ){
      return null;
    }

    //if( !data.value ){ debugger; }


    return component && (
      <CollapsibleSection sectionTitle={menuKey} titleStyle={sectionHeaderStyle} defaultOpen={possibleActionEntries.length === 1 || DEFAULT_OPEN_SET.has(menuKey)||false}>
      {React.createElement(component,{
        onEvent:(
          customEventHandler[menuKey] || standardEventResponse),
        selectedFigureItems,
        figurePanelId,
        data,
        args:menuArgs,
      })}
      </CollapsibleSection>
    )


  })


 


  return (
    <>


      <div style={{
        overflow:'visible',
      }} id={"figure-info-sidebar"} class={"figure-info-sidebar"}>

       
        
        {false && <div>{JSON.stringify(selectedFigureItems)}</div>}

        

        
        {false && <div>
          <pre style={{fontSize:8}}>
          
            <span style={{color:"blue"}}>{true && JSON.stringify(data,null,1)}</span>
          </pre>
        </div>
        }


        
        {sidebarMenus}

        <div class="sg-col">
        </div>
      </div>
    </>
  )
    

}
